import { LOCALES } from 'i18n/locales';

export const paginationIntl = {
    [LOCALES.ENGLISH]: {
        'pagination.next': 'Next',
        'pagination.previous': 'Previous',
        'pagination.page': 'page'
    },
    [LOCALES.WELSH]: {
        'pagination.next': 'Nesaf',
        'pagination.previous': 'Blaenorol',
        'pagination.page': 'tudalen'
    }
};
